export const ChevronRightIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      {...props}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.24955 14C0.93194 14 0.614328 13.8855 0.363582 13.6401C-0.121194 13.1656 -0.121194 12.3804 0.363582 11.9059L5.37851 6.99795L0.363582 2.08998C-0.121194 1.61554 -0.121194 0.830266 0.363582 0.355828C0.848358 -0.118609 1.65075 -0.118609 2.13552 0.355828L8.03642 6.13088C8.52119 6.60532 8.52119 7.39059 8.03642 7.86503L2.13552 13.6401C1.88478 13.8855 1.56716 14 1.24955 14Z"
        fill="currentColor"
      />
    </svg>
  );
};
